import React, { forwardRef } from 'react'
import { styled } from 'styletron-react'
import { lightTheme } from '@/customTheme'
import { FloatingInspectorButtonArrow, FloatingInspectorButtonHandle, PopoverContentType } from '../../FloatingInspectorButton/FloatingInspectorButton'
import RoundedButton from './RoundedButton'

const ProductCircle = styled('div', (props: { $src?: string }) => ({
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundImage: props.$src ? `url('${props.$src}')` : 'none',
  backgroundColor: props.$src ? 'transparent' : lightTheme.colors.grayScale100,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}))

export interface SuggestedButtonImageInCircleProps {
  src?: string
  text?: string
  onClick?: () => void
  tooltipText?: string
  popoverContent?: PopoverContentType
  showArrow?: FloatingInspectorButtonArrow
}

const SuggestedButtonImageInCircle = forwardRef<FloatingInspectorButtonHandle, SuggestedButtonImageInCircleProps>(
  ({ src, text, onClick, tooltipText, popoverContent, showArrow }, ref) => {
    return (
      <RoundedButton
        ref={ref}
        icon={<ProductCircle $src={src} />}
        iconSize={30}
        styleOverride={{ padding: '3px 12px 3px 3px' }}
        text={text}
        onClick={onClick}
        tooltipText={tooltipText}
        popoverContent={popoverContent}
        showArrow={showArrow}
      />
    )
  }
)

export default SuggestedButtonImageInCircle
